import { jsx as _jsx } from "react/jsx-runtime";
import { useFormatting } from "../formatting/useFormatting.js";
import { LabeledValue } from "./LabeledValue.js";
export const LabeledDateValue = ({ label, value, align, icon, notSetText, labelProps, }) => {
    const { getFormattedDate } = useFormatting();
    return (_jsx(LabeledValue, { label: label, align: align, icon: icon, labelProps: labelProps, notSet: !value, children: value ? getFormattedDate(value) : notSetText }));
};
//# sourceMappingURL=LabeledDateValue.js.map